import type { ApiClientOptions } from '@/infra/api-client'
import { patchGrpcClient } from '@/utils/grpc-util'
import { IndividualProfileServicePromiseClient } from '@taxfyle/api-internal/internal/individual_profile_grpc_web_pb'
import { BusinessProfileServicePromiseClient } from '@taxfyle/api-internal/internal/business_profile_grpc_web_pb'
import { TaxRefundMethodServicePromiseClient } from '@taxfyle/api-internal/internal/tax_refund_methods_grpc_web_pb'

export class TaxProfileApi {
  readonly individualProfiles
  readonly businessProfiles
  readonly taxRefundMethods

  constructor(options: ApiClientOptions) {
    const baseURL = options.baseURL ?? ''

    this.individualProfiles = new IndividualProfileServicePromiseClient(baseURL)
    patchGrpcClient(this.individualProfiles, options.token$)

    this.businessProfiles = new BusinessProfileServicePromiseClient(baseURL)
    patchGrpcClient(this.businessProfiles, options.token$)

    this.taxRefundMethods = new TaxRefundMethodServicePromiseClient(baseURL)
    patchGrpcClient(this.taxRefundMethods, options.token$)
  }
}
